export default __webpack_public_path__ + "static/media/solutions-banner.64de6b13.png";